const animatedConfettiUrl = "https://bounce-web.s3.us-east-2.amazonaws.com/animations/animated-confetti.json";
const animatedKeepWaitingUrl = "https://bounce-web.s3.us-east-2.amazonaws.com/animations/keep-waiting.gif";
const animatedNotFoundUrl = "https://bounce-web.s3.us-east-2.amazonaws.com/animations/not-found.gif";
const HAPPY_MONEY_PORTAL_URL = "https://go.happymoney.com/apply-login";
const S3_BASE_URL = "https://bounce-web.s3.us-east-2.amazonaws.com";

export {
  animatedConfettiUrl,
  animatedKeepWaitingUrl,
  animatedNotFoundUrl,
  HAPPY_MONEY_PORTAL_URL,
  S3_BASE_URL,
};
